import React, { useState } from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { Mail, Phone, MapPin, Send } from 'lucide-react';
const ContactPage = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitSuccess, setSubmitSuccess] = useState(false);
  const handleChange = e => {
    const {
      name,
      value
    } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };
  const handleSubmit = e => {
    e.preventDefault();
    setIsSubmitting(true);
    // Simulate form submission
    setTimeout(() => {
      setIsSubmitting(false);
      setSubmitSuccess(true);
      setFormData({
        name: '',
        email: '',
        subject: '',
        message: ''
      });
      // Reset success message after 5 seconds
      setTimeout(() => {
        setSubmitSuccess(false);
      }, 5000);
    }, 1500);
  };
  return <div className="min-h-screen bg-white" data-id="element-347" data-mp="r0yawiegfs89">
      <Navbar data-id="element-348" data-mp="qykikhb5su4e" />
      {/* Hero Section */}
      <div className="relative bg-gradient-to-r from-teal-900 to-teal-800 text-white" data-id="element-349" data-mp="myjs1yascsgz">
        <div className="absolute inset-0 overflow-hidden" data-id="element-350" data-mp="hzqiui2j7nmm">
          <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1557804506-669a67965ba0?ixlib=rb-4.0.3&auto=format&fit=crop&w=2000&q=80')] bg-cover bg-center opacity-20" data-id="element-351" data-mp="hy5oasg7w4or"></div>
        </div>
        <div className="relative container mx-auto px-4 py-24 max-w-7xl" data-id="element-352" data-mp="83nfj8vy1iy3">
          <div className="max-w-3xl" data-id="element-353" data-mp="39j9qsyezgyl">
            <h1 className="text-4xl md:text-5xl font-bold mb-4" data-id="element-354" data-mp="3vewk9c46bw3m">Contact Us</h1>
            <p className="text-xl mb-8 text-teal-100" data-id="element-355" data-mp="3vcsip0tqz96i">
              Have questions about our products or research? Get in touch with
              our team.
            </p>
          </div>
        </div>
      </div>
      {/* Main Content */}
      <div className="container mx-auto px-4 py-16 max-w-7xl" data-id="element-356" data-mp="3gh47grq0hlt4">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12" data-id="element-357" data-mp="3gjyp6bhn4siu">
          {/* Contact Form */}
          <div data-id="element-358" data-mp="36wcxg1ur6zo4">
            <h2 className="text-2xl font-bold text-gray-800 mb-6" data-id="element-359" data-mp="3bt398cziz93q">
              Send Us a Message
            </h2>
            {submitSuccess ? <div className="bg-green-50 border border-green-200 rounded-lg p-6 mb-6" data-id="element-360" data-mp="2xun3opdefon6">
                <h3 className="text-green-800 font-medium text-lg mb-2" data-id="element-361" data-mp="31vyqkn4w1vro">
                  Message Sent Successfully!
                </h3>
                <p className="text-green-700" data-id="element-362" data-mp="3pmktk001cput">
                  Thank you for reaching out. We'll get back to you as soon as
                  possible.
                </p>
              </div> : <form onSubmit={handleSubmit} className="space-y-6" data-id="element-363" data-mp="3ktrr5is1htlw">
                <div data-id="element-364" data-mp="3kryixz1s31bs">
                  <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-365" data-mp="3krf1ejg1ieya">
                    Your Name
                  </label>
                  <input type="text" id="name" name="name" value={formData.name} onChange={handleChange} required className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-600 focus:border-teal-600 outline-none transition" placeholder="John Doe" data-id="element-366" data-mp="21v3iug7rksz3" />
                </div>
                <div data-id="element-367" data-mp="1iybwtz0u7zrc">
                  <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-368" data-mp="1dxecbfscutmo">
                    Email Address
                  </label>
                  <input type="email" id="email" name="email" value={formData.email} onChange={handleChange} required className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-600 focus:border-teal-600 outline-none transition" placeholder="your@email.com" data-id="element-369" data-mp="1nv2kp8ivvznb" />
                </div>
                <div data-id="element-370" data-mp="1htk73sb35ux9">
                  <label htmlFor="subject" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-371" data-mp="1ht0kvzeekkdf">
                    Subject
                  </label>
                  <input type="text" id="subject" name="subject" value={formData.subject} onChange={handleChange} required className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-600 focus:border-teal-600 outline-none transition" placeholder="Product Inquiry" data-id="element-372" data-mp="1rrq5w11likxw" />
                </div>
                <div data-id="element-373" data-mp="2filrggfgkjwp">
                  <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-374" data-mp="2ffpw8zuzw9by">
                    Your Message
                  </label>
                  <textarea id="message" name="message" value={formData.message} onChange={handleChange} required rows={6} className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-teal-600 focus:border-teal-600 outline-none transition" placeholder="How can we help you?" data-id="element-375" data-mp="2fnl552cwa59a"></textarea>
                </div>
                <button type="submit" disabled={isSubmitting} className={`inline-flex items-center px-6 py-3 bg-teal-600 text-white font-medium rounded-lg hover:bg-teal-700 transition-colors duration-300 ${isSubmitting ? 'opacity-70 cursor-not-allowed' : ''}`} data-id="element-376" data-mp="2ul3p7remnuae">
                  {isSubmitting ? <>
                      <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" data-id="element-377" data-mp="1pdazisunkp4d">
                        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" data-id="element-378" data-mp="1flod00cv73mb"></circle>
                        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" data-id="element-379" data-mp="rs6jvlc42p5a"></path>
                      </svg>
                      Sending...
                    </> : <>
                      Send Message <Send size={16} className="ml-2" data-id="element-380" data-mp="ah9dzcs6yj7w" />
                    </>}
                </button>
              </form>}
          </div>
          {/* Contact Information */}
          <div data-id="element-381" data-mp="kdmfuxxw43dq">
            <h2 className="text-2xl font-bold text-gray-800 mb-6" data-id="element-382" data-mp="kd2z3kjz7l1a">
              Get in Touch
            </h2>
            <div className="bg-gray-50 rounded-lg p-8 border border-gray-100" data-id="element-383" data-mp="y495m0loaixo">
              <div className="space-y-6" data-id="element-384" data-mp="u3p8uy50hhc2">
                <div className="flex items-start" data-id="element-385" data-mp="u6tmem4d9pfe">
                  <MapPin size={24} className="text-teal-600 mr-4 mt-1 flex-shrink-0" data-id="element-386" data-mp="182xarysk73jy" />
                  <div data-id="element-387" data-mp="133c75b2g270w">
                    <h3 className="font-medium text-gray-800 mb-1" data-id="element-388" data-mp="39v3cox3oomky">
                      Our Location
                    </h3>
                    <p className="text-gray-600" data-id="element-389" data-mp="34xtofks16gyp">
                      123 Science Way, San Francisco, CA 94107
                    </p>
                  </div>
                </div>
                <div className="flex items-start" data-id="element-390" data-mp="2o1nvog5l3p6u">
                  <Phone size={24} className="text-teal-600 mr-4 mt-1 flex-shrink-0" data-id="element-391" data-mp="2o0cvsrf9f1l0" />
                  <div data-id="element-392" data-mp="2xsilfui1h6x1">
                    <h3 className="font-medium text-gray-800 mb-1" data-id="element-393" data-mp="2xrpkxb9obdnc">Phone</h3>
                    <p className="text-gray-600" data-id="element-394" data-mp="205a0c0ly9zvk">(123) 456-7890</p>
                  </div>
                </div>
                <div className="flex items-start" data-id="element-395" data-mp="254cyd13ij5u1">
                  <Mail size={24} className="text-teal-600 mr-4 mt-1 flex-shrink-0" data-id="element-396" data-mp="2a2o9df5jnmdu" />
                  <div data-id="element-397" data-mp="2f2ssze1r0x8a">
                    <h3 className="font-medium text-gray-800 mb-1" data-id="element-398" data-mp="2f32jr3umb8f1">Email</h3>
                    <p className="text-gray-600" data-id="element-399" data-mp="3lh1qm15sl3kw">info@calbiome.com</p>
                  </div>
                </div>
              </div>
              {/* Map Placeholder */}
              <div className="mt-8 rounded-lg overflow-hidden border border-gray-200 h-64 bg-gray-100" data-id="element-400" data-mp="1eu2pmipz59kw">
                <img src="https://images.unsplash.com/photo-1569336415962-a4bd9f69cd83?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80" alt="Map location" className="w-full h-full object-cover" data-id="element-401" data-mp="19u80ajluks1y" />
              </div>
            </div>
            {/* Office Hours */}
            <div className="mt-8 bg-gray-50 rounded-lg p-8 border border-gray-100" data-id="element-402" data-mp="v752scxiyjem">
              <h3 className="text-xl font-bold text-gray-800 mb-4" data-id="element-403" data-mp="r374g4g0xcmm">
                Office Hours
              </h3>
              <ul className="space-y-2" data-id="element-404" data-mp="m55lrkmiffbo">
                <li className="flex justify-between" data-id="element-405" data-mp="h62dzsf5av00">
                  <span className="text-gray-600" data-id="element-406" data-mp="h7dm24fmiowx">Monday - Friday:</span>
                  <span className="font-medium text-gray-800" data-id="element-407" data-mp="2ghvew0520ki0">
                    9:00 AM - 5:00 PM
                  </span>
                </li>
                <li className="flex justify-between" data-id="element-408" data-mp="2bi0p5zx0m0yj">
                  <span className="text-gray-600" data-id="element-409" data-mp="xec86zaee8ot">Saturday:</span>
                  <span className="font-medium text-gray-800" data-id="element-410" data-mp="sgkdxyma6ahg">
                    10:00 AM - 2:00 PM
                  </span>
                </li>
                <li className="flex justify-between" data-id="element-411" data-mp="16fjqw90fl0xs">
                  <span className="text-gray-600" data-id="element-412" data-mp="12erj7k77j43m">Sunday:</span>
                  <span className="font-medium text-gray-800" data-id="element-413" data-mp="12cdnd94pdnv0">Closed</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
        {/* FAQ Section */}
        <div className="mt-16" data-id="element-414" data-mp="9rdprw2pwqo9">
          <h2 className="text-2xl font-bold text-gray-800 mb-8" data-id="element-415" data-mp="nh7fshpylgzk">
            Frequently Asked Questions
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-416" data-mp="ipz8br86w5p1">
            <div className="bg-white rounded-lg p-6 border border-gray-200" data-id="element-417" data-mp="ioo3do30crwc">
              <h3 className="text-lg font-bold text-gray-800 mb-3" data-id="element-418" data-mp="3r4hko555y7eg">
                How can I purchase CalBiome products?
              </h3>
              <p className="text-gray-600" data-id="element-419" data-mp="3d125c6oq1lql">
                Our products are available through our online store and select
                healthcare practitioners. Visit our Products page to learn more
                about purchasing options.
              </p>
            </div>
            <div className="bg-white rounded-lg p-6 border border-gray-200" data-id="element-420" data-mp="330romc3h9w6o">
              <h3 className="text-lg font-bold text-gray-800 mb-3" data-id="element-421" data-mp="381yyqht3f7gi">
                Do you offer international shipping?
              </h3>
              <p className="text-gray-600" data-id="element-422" data-mp="4kp5q7t07ftx">
                Yes, we ship to select international locations. Shipping costs
                and delivery times vary by destination. Please contact our
                customer service team for details.
              </p>
            </div>
            <div className="bg-white rounded-lg p-6 border border-gray-200" data-id="element-423" data-mp="3qu01vwcwhjvq">
              <h3 className="text-lg font-bold text-gray-800 mb-3" data-id="element-424" data-mp="2acm4nrk90b7w">
                What is the Microbiota Reset Protocol?
              </h3>
              <p className="text-gray-600" data-id="element-425" data-mp="lut1d5erae4f">
                The Microbiota Reset Protocol is our flagship program designed
                to optimize gut health through a comprehensive approach
                including probiotics, biofilm disruptors, and targeted
                nutrients.
              </p>
            </div>
            <div className="bg-white rounded-lg p-6 border border-gray-200" data-id="element-426" data-mp="74dc9fj7ym0z">
              <h3 className="text-lg font-bold text-gray-800 mb-3" data-id="element-427" data-mp="26tsk03r5h1n">
                How can I become a research partner?
              </h3>
              <p className="text-gray-600" data-id="element-428" data-mp="3u8jlmihcd08b">
                We actively collaborate with academic institutions and research
                organizations. Please reach out to our research department via
                email at research@calbiome.com to discuss potential
                partnerships.
              </p>
            </div>
          </div>
        </div>
      </div>
      <Footer data-id="element-429" data-mp="1illlce4t8qbh" />
    </div>;
};
export default ContactPage;